import {getEventObj} from "../atBrowserUtils"

export default class SelectionScrollController {
    constructor() {
        this.enabled = false;
    }

    setEnabled(enabled) {
        if (this.enabled == enabled)
            return;

        if (enabled) {
            //subscribe
            var previousMousemove = document.onmousemove;
            var self = this;
            this.previousMousemove = previousMousemove;
            document.onmousemove = function(evt) {
                if (previousMousemove)
                    previousMousemove.call(this, evt);

                self.scroll(evt);
            };
            this.enabled = true;
        }
        else {
            //unsubscribe
            document.onmousemove = this.previousMousemove;
            this.enabled = false;
        }
    }

    scroll(evt) {
        evt = getEventObj(evt);
        this.mousePosX = evt.clientX;
        this.mousePosY = evt.clientY;

        var self = this;
        var doScroll = function() {
            var dx = 0;
            var dy = 0;

            if (self.mousePosX < 50) dx = -10;
            if (document.body.clientWidth - self.mousePosX < 50) dx = 10;
            if (self.mousePosY < 50) dy = -10;
            if (document.body.clientHeight - self.mousePosY < 50) dy = 10;

            window.scrollBy(dx, dy); // horizontal and vertical scroll increments

            if (self.enabled && ( dx != 0 || dy != 0 )) {
                self.scrollTid = setTimeout(doScroll, 20);
            }
            else {
                self.scrollTid = null;
            }
        };

        if (!this.scrollTid) {
            doScroll();
        }
    }

    linkTo(lockTable) {
        var self = this;
        //enable on selection start
        lockTable.getSelectionController().addSelectionChangeListener(
            function(selectionChangeEvent) {
                self.setEnabled(selectionChangeEvent.newValue != null);
            }
        );

        //disable on selection complete
        lockTable.addLockEventsListener({
            selectionRemoved() {},
            selectionFinished() { self.setEnabled(false); },
            userDayClicked() { self.setEnabled(false); }
        });
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/SelectionScrollController.js